import $ from 'jquery';

import {
  register
} from '../../sections/ShopifySection';
import {
  ON_CART_FINISHED,
  getCurrentCart,
  printMoney
} from '@process-creative/slate-theme-tools';

const SPEND_SAVE_SELECTOR = '[data-cart-template]';

export const SPEND_SAVE_TITLE_SELECTOR = 'data-spendnsave';

const SPEND_SAVE_TITLE_SELECTOR_TITLE = `[data-spendnsave-title]`;
const SPEND_SAVE_TITLE_SELECTOR_BAR_WRAPPER = `[data-spendnsave-bar-wrapper]`;
const SPEND_SAVE_TITLE_SELECTOR_BAR = `[data-spendnsave-bar]`;
const SPEND_SAVE_TITLE_SELECTOR_STEPS = `[data-spendnsave-steps]`;


const TOPBAR_REWARDS_DATA = '[data-topbar-rewards-data]';
const TOPBAR_REWARDS_EXCLUDE = '[data-topbar-rewards-exclude]';
const CART_TEMPLATE_SUBTOTAL_SNS_MESSAGE_BODY = '[data-cart-template-subtotal-spendnsave-message-body]';


export class CartPromoMessage {
  constructor(container) {
    this.container = container;
    this.ssTitle = container.find(SPEND_SAVE_TITLE_SELECTOR_TITLE);
    this.ssBar = container.find(SPEND_SAVE_TITLE_SELECTOR_BAR);
    this.ssBarWrapper = container.find(SPEND_SAVE_TITLE_SELECTOR_BAR_WRAPPER);
    this.ssSteps = container.find(SPEND_SAVE_TITLE_SELECTOR_STEPS);
    this.data = '';
    try {
      this.data = JSON.parse($(TOPBAR_REWARDS_DATA).html());
    } catch (error) {
      console.error(error);
    }

    this.addMessage();
    $(document).on(ON_CART_FINISHED, () => this.addMessage());
  }

  addMessage() {
    let cart = getCurrentCart();
    let promoArray = this.getRewardsData(cart);
    let subtotal = cart.original_total_price;
    if (!promoArray || promoArray.length != 4) return;
    $(document).find(CART_TEMPLATE_SUBTOTAL_SNS_MESSAGE_BODY).first().html(Language.strings['cart.layout.free_shipping']);

    // Get first goal that is more than subtotal, if none, then null
    let nextGoal = this.data.find(promo => promo.goal_amount > subtotal) || null;
    // if nextGoal is null, discount has been achieved, so set to 1
    let nextGoalInterger = nextGoal === null ? 1 : parseInt(nextGoal.goal_amount);
    // get percentage to next goal
    let percentageToGoal = subtotal / nextGoalInterger * 100;

    this.ssTitle.html(promoArray[0]);
    this.ssBar[0].style.width = `calc(${percentageToGoal}% - 1rem)`;
  }

  getRewardsData(cart) {
    let currentTier = [];
    let cartPromoMessage = '';
    let title = Language.strings['cart.spendnsave.title'];

    let excludedProducts;
    if ($(TOPBAR_REWARDS_EXCLUDE).length && $(TOPBAR_REWARDS_EXCLUDE).html() != '') {
      excludedProducts = JSON.parse($(TOPBAR_REWARDS_EXCLUDE).html().replace(/,\s*}/, "}")); //todo: a better way to parse data
    }

    this.data.some(block => {
      if (!block.goal_amount) {
        //reached max tier amount
        let maxTierTitle = Language.strings['cart.spendnsave.max_tier_title'];
        currentTier.push(maxTierTitle, block.title, 100, cartPromoMessage);
        return true;
      }

      let excludeAmount = 0; // exclude product price
      let lineItems = cart.items;

      if (excludedProducts && lineItems) {
        for (let index = 0; index < lineItems.length; index++) {
          if (excludedProducts[parseInt(lineItems[index].product_id)]) {
            excludeAmount = excludeAmount + lineItems[index].final_price * lineItems[index].quantity;
          }
        }
      }

      if ((cart.original_total_price - excludeAmount) >= block.goal_amount) {
        //get the previous tier message
        cartPromoMessage = this.getCartPromoMessage(title, block);
        return false;
      }

      currentTier = this.getTierMessage(title, block, cart, excludeAmount);
      currentTier.push(cartPromoMessage);

      return true;
    });

    return currentTier;

  }

  //progress bar message
  getTierMessage(title, tier, cart, excludeAmount) {
    if (title == null || tier == null || cart == null || excludeAmount == null) return;
    let tierMessage = [];
    let maxTier = this.getMaxTier();

    if (!maxTier) return;

    let totalTier = this.data.length - 1;
    let currentTier = this.data.indexOf(tier);
    let progressInital = currentTier / totalTier;
    let totalPrice = cart.original_total_price - excludeAmount;
    let progressTotal = progressInital + (1 / totalTier) * (totalPrice / tier.goal_amount);

    let discount = tier.title.match(/\d+%/im);
    let body = Language.strings['cart.spendnsave.body'];

    if (!discount) discount = tier.title.match(/\$\d+/im); //try match a fixed discount rather than %
    if (discount) title = title.replace(/\$discount\$/gim, discount);

    if (title.match(/\$goal\$/gim)) title = title.replace(/\$goal\$/gim, `${printMoney(tier.goal_amount - cart.original_total_price + excludeAmount)} more`);

    if (body.match(/\$amount\$/gim)) body = body.replace(/\$amount\$/gim, printMoney(tier.goal_amount - cart.original_total_price + excludeAmount));

    let percentage = (progressTotal * 100).toFixed(2);
    tierMessage.push(title, body, percentage);

    return tierMessage;
  }

  //promo message in the subtotal panel
  getCartPromoMessage(title, tier) {
    if (!title || !tier) return;
    let discount = tier.title.match(/\d+%/im);

    if (!discount) discount = tier.title.match(/\$\d+/im); //try match a fixed discount rather than %
    if (discount) title = title.replace(/\$discount\$/gim, discount);

    if (title.match(/\$goal\$/gim)) title = title.replace(/\$goal\$/gim, printMoney(tier.goal_amount));
    return title;
  }

  getMaxTier() {
    const maxTier = this.data.reduce(function (prev, current) {
      return (prev.goal_amount > current.goal_amount) ? prev : current
    })
    if (!maxTier) return null;
    return maxTier;
  }

}


register(SPEND_SAVE_SELECTOR, CartPromoMessage);